<template>
  <v-app class="custom__bg mt-1">
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <v-list-item-group dark>
            <v-list-item
              v-for="item in items"
              :key="item.subject"
              :to="item.to"
            >
              <v-list-item-avatar size="150">
                <v-avatar :color="item.color" size="150"> </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title>
                <h2 class="display-1 font-weight-bold black--text">
                  {{ item.subject }}
                </h2>
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item-group dark>
            <v-list-item
              v-for="item in items"
              :key="item.subject"
              :to="item.to"
            >
              <v-list-item-avatar size="150">
                <v-avatar :color="item.color" size="150"> </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title>
                <h2 class="display-1 font-weight-bold black--text">
                  {{ item.subject }}
                </h2>
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        subject: "Mathematics",
        color: "orange",
        to: "",
      },
      {
        subject: "English",
        color: "red",
      },
      {
        subject: "Geography",
        color: "orange",
      },
      {
        subject: "Agricultural Science",
        color: "orange",
      },
    ],
  }),
};
</script>
<style scoped>
.custom__bg {
  background: url("../assets/chat.svg");
}
</style>
